import { useCallback, useContext, useState } from 'react';

import { ISelectOption } from '@smartshell/ui-kit';

import { CashboxContext, IKKM } from 'cashbox';

interface IReturnValue {
  KKMsOptions: Array<ISelectOption<string, IKKM>>;
  isKKMsLoading: boolean;
  loadKKMs: () => Promise<void>;
}
export const useKKMSOptions = (): IReturnValue => {
  const [isKKMsLoading, setIsKKMsLoading] = useState(false);
  const [KKMsOptions, setKKMsOptions] = useState<
    Array<ISelectOption<string, IKKM>>
  >([]);

  const { loadKKMs: serviceLoadKKMS } = useContext(CashboxContext);

  const loadKKMs = useCallback(() => {
    setIsKKMsLoading(true);

    return serviceLoadKKMS()
      .then((response) => {
        setKKMsOptions(
          response.ListUnit.filter((unit) => unit.INN).map((unit) => ({
            value: unit.INN,
            title: unit.NameDevice,
            original: unit,
          }))
        );
      })
      .finally(() => setIsKKMsLoading(false));
  }, []);

  return {
    KKMsOptions,
    loadKKMs,
    isKKMsLoading,
  };
};
